/* global breeds, charmDefault, bodyScrollLock, Shopify */
class Personalizer extends HTMLElement {
  constructor() {
    // Always call super first in constructor
    super();

    // write element functionality in here
    this.enableName = this.dataset.enableName;
    this.setData();
    this.getElement();
    this.addEventModal();
    this.initSwiper();
    this.addEventStep();
    this.addEventButton();
    this.validateButton();
    this.addEventBundle();
    this.addEventCustomize();
  }

  setData() {
    this.config = {
      selectedClass: "selected",
      showClass: "show",
    };
    if (this.enableName === "true") {
      this.steps = {
        color: 0,
        breed: 1,
        name: 2,
        halo: 3,
        final: 4,
      };
    } else {
      this.steps = {
        color: 0,
        breed: 1,
        halo: 2,
        final: 3,
      };
    }
    this.currentStep = "color";
    this.properties = {
      color: "",
      breed: "",
      name: "",
      halo: "",
    };
    this.breedCharm = {};

    this.productHandle = this.getAttribute("data-product");
  }

  getElement() {
    this.innerEl = this.querySelector(".js-personalizer-inner");
    this.breedImageEls = this.querySelectorAll(".js-breed-image");
    this.variantId = this.querySelector(".js-variant-id");
    this.priceEls = this.querySelectorAll(".js-price");
    this.buttonClose = this.querySelector(".js-button-close");
    this.overlay = this.querySelector(".js-overlay");
    this.buttonCustomize = document.querySelector(".js-button-customize");
    this.removes = this.querySelectorAll(".js-remove");
    this.buttonCustomiseEls = this.querySelectorAll(".js-button-customise");

    this.buttonBundleEls = this.querySelectorAll(".js-bundle-final-button");
    this.viewCartEl = this.querySelector(".js-view-cart");
  }

  addEventBundle() {
    if (!this.buttonBundleEls) {
      return;
    }
    this.buttonBundleEls.forEach((button) => {
      button.addEventListener("click", () => {
        button.disabled = true;
        button.textContent = "Adding...";
        const data = {
          id: this.variantId.value,
          properties: this.properties,
          quantity: 1,
        };
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .then((data) => {
            const nextStep = button.dataset.nextStep;
            if (nextStep === "keychain" || nextStep === "bracelet") {
              setTimeout(() => {
                button.textContent = "Added to Cart";
                button.disabled = false;
                const nextStepEl = document.querySelector(
                  ".js-bundle-" + nextStep
                );
                if (nextStepEl) {
                  nextStepEl.classList.add("active");
                }
              }, 1000);
            }
            if (nextStep === "bundle") {
              button.textContent = "Added Bundle to Cart";
              button.disabled = false;
              setTimeout(() => {
                window.location.href = "/cart";
              }, 1000);
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      });
    });
  }

  addEventCustomize() {
    this.buttonCustomiseEls.forEach((buttonAtc) => {
      buttonAtc.addEventListener("click", () => {
        const handle = buttonAtc.dataset.handle;
        this.closeModal();
        this.openModal(handle);
      });
    });
  }

  closeModal() {
    this.classList.remove("open");
    bodyScrollLock.clearAllBodyScrollLocks();
  }

  resetAll() {
    this.properties = {
      color: "",
      breed: "",
      name: "",
      halo: "",
    };
    this.currentStep = "color";
    this.resetStep("color");
    this.resetStep("breed");
    if (this.enableName === "true") {
      this.resetStep("name");
    }
    this.resetStep("halo");
    this.goToStep("color");
    this.validateButton();
  }

  openModal(handle) {
    const modal = document.querySelector(
      `.js-personalizer[data-product="${handle}"]`
    );
    // eslint-disable-next-line no-console
    console.log("modal", modal);

    if (modal) {
      this.resetAll();
      this.classList.remove("open");
      modal.classList.add("open");

      bodyScrollLock.disableBodyScroll(
        modal.querySelector(".js-personalizer-inner")
      );
    }
  }

  formatMoney(cents, formatString = Shopify.money_format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      const parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";
      return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  async updateViewCart() {
    const cart = await fetch("/cart.js");
    const cartJson = await cart.json();

    const countEl = this.viewCartEl.querySelector(".js-cart-count");
    const priceEl = this.viewCartEl.querySelector(".js-cart-price");

    countEl.textContent = cartJson.item_count;
    priceEl.textContent = this.formatMoney(cartJson.total_price);

    this.headerCartCountEl = document.querySelector(".js-header-cart-count");
    this.headerCartCountEl.textContent = cartJson.item_count;
    this.headerCartCountEl?.classList.remove("hidden");
  }

  async addAtc() {
    const buttonAtc = this.querySelector('.js-button[data-step="halo"]');
    if (!buttonAtc) {
      return;
    }
    buttonAtc.disabled = true;
    buttonAtc.textContent = "Adding...";
    const data = {
      id: this.variantId?.value,
      properties: this.properties,
      quantity: 1,
    };
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const result = await res.json();
      buttonAtc.textContent = "Added to cart";
      // window.location.href = "/cart";
      buttonAtc.disabled = false;
      this.goToStep("final");
      await this.updateViewCart();
    } catch (error) {
      console.error("Error:", error);
    }
  }

  addEventModal() {
    if (this.buttonCustomize) {
      this.buttonCustomize.addEventListener("click", () => {
        const productHandle = this.buttonCustomize.dataset.handle;
        if (this.productHandle !== productHandle) {
          return;
        }
        this.classList.add("open");
        bodyScrollLock.disableBodyScroll(this.innerEl);
      });
    }
    if (this.buttonClose) {
      this.buttonClose.addEventListener("click", () => {
        this.classList.remove("open");
        bodyScrollLock.clearAllBodyScrollLocks();
      });
    }
    if (this.overlay) {
      this.overlay.addEventListener("click", () => {
        this.classList.remove("open");
        bodyScrollLock.clearAllBodyScrollLocks();
      });
    }
  }

  initSwiper() {
    this.swiperEl = this.querySelector("swiper-container");
  }

  async goToStep(step) {
    if (step === "atc") {
      await this.addAtc();
      return;
    }

    this.currentStep = step;

    Object.keys(this.steps).forEach((key) => {
      this.classList.remove(key);
    });
    this.classList.add(step);

    const stepIndex = this.steps[step];
    this.swiperEl.swiper.slideTo(stepIndex);
    this.validateButton();
    this.toggleBreedResults();
  }

  addEventButton() {
    const buttons = this.querySelectorAll(".js-button");
    buttons?.forEach((button) => {
      button.addEventListener("click", () => {
        const step = button.dataset.nextStep;
        console.log("step", step);
        this.goToStep(step);
      });
    });

    this.viewCartEl?.addEventListener("click", () => {
      this.viewCartEl.querySelector(".js-cart-text").textContent =
        "Redirecting to cart...";
      window.location.href = "/cart";
    });
  }

  stepColor() {
    const selectedColorEl = this.querySelector(".js-color-selected");
    this.colors = this.querySelectorAll(".js-color-item");
    this.colors?.forEach((color) => {
      color.addEventListener("click", () => {
        this.properties.color = color.dataset.color;
        this.resetStep("color");
        color.classList.add(this.config.selectedClass);
        selectedColorEl.textContent = color.dataset.color;
        this.validateButton();
        this.changeBreedImage();
      });
    });
  }

  changeBreedImage() {
    const breedImage = this.breedCharm[this.properties.color];
    if (breedImage) {
      this.breedImageEls.forEach((el) => {
        el.src = breedImage;
        el.addEventListener("load", () => {
          el.classList.add("active");
        });
      });
    }
  }

  addEventBreedItems() {
    this.breedItems = this.querySelectorAll(".js-breed-item");
    this.breedItems.forEach((el) =>
      el.addEventListener("click", () => {
        this.breedItems.forEach((item) => item.classList.remove("active"));
        el.classList.add("active");
        this.breedEl.value = el.dataset.name;
        this.properties.breed = el.dataset.name;
        this.breedCharm = {
          Silver: el.dataset.silverCharm,
          Gold: el.dataset.goldCharm,
          "Rose Gold": el.dataset.roseGoldCharm,
        };
        this.changeBreedImage();
        this.validateButton();
        this.toggleBreedResults();
      })
    );
  }

  getBreedByValue(value = null) {
    this.breedResults = value
      ? breeds.filter(
          (breed) =>
            breed.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
        )
      : breeds;
    this.breedResultsEl.innerHTML = null;
    if (this.breedResults.length > 0) {
      this.breedResults?.forEach((breed) => {
        const activeClass =
          this.properties.breed === breed.name ? "active" : "";

        let breed_charm = breed.gold_charm;

        if (this.properties?.color === "Silver") {
          breed_charm = breed.silver_charm;
        }

        if (this.properties?.color === "Rose Gold") {
          breed_charm = breed.rose_gold_charm;
        }

        this.breedResultsEl.insertAdjacentHTML(
          "beforeend",
          `
          <li
            class="${activeClass} js-breed-item"
            data-name="${breed.name}"
            data-silver-charm="${breed.silver_charm}"
            data-gold-charm="${breed.gold_charm}"
            data-rose-gold-charm="${breed.rose_gold_charm}"
          >
            <img src="${breed_charm}" alt="${breed.name}" />
            <span>${breed.name}</span>
          </li>
        `
        );
      });
    } else {
      // const breedNot = breeds.find(breed => breed.name.toUpperCase() === 'NOT LISTED')
      this.breedResultsEl.insertAdjacentHTML(
        "beforeend",
        `
          <li>
            <span>Breed not found. Try a similar search</span>
          </li>
        `
      );
    }
    this.addEventBreedItems();
  }

  toggleBreedResults(show = false) {
    if (show) {
      this.breedWrapperEl.classList.add("active");
      // eslint-disable-next-line no-console
      console.log("this.breedResultsEl", this.breedResultsEl);

      bodyScrollLock.disableBodyScroll(this.breedResultsEl);
    } else {
      this.breedWrapperEl.classList.remove("active");
      // eslint-disable-next-line no-console
      console.log("this.innerEl", this.innerEl);

      bodyScrollLock.disableBodyScroll(this.innerEl);
    }
    // this.breedEl.value = this.properties.breed
  }

  stepBreed() {
    this.breedWrapperEl = this.querySelector(".js-personalizer-breed");
    this.breedEl = this.querySelector(".js-pet-breed");
    this.breedResultsEl = this.querySelector(".js-pet-breed-results");
    this.breedEl.addEventListener(
      "input",
      this.debounce((e) => {
        const value = e.target.value;
        this.getBreedByValue(value);
      })
    );
    this.breedEl.addEventListener("focus", (e) => {
      this.toggleBreedResults(true);
      this.getBreedByValue();
    });
    // this.getBreedByValue();
  }

  stepName() {
    this.nameEl = this.querySelector(".js-personalizer-name");
    const nameType = this.nameEl.dataset.type;
    this.previewEl = this.querySelector(".js-font-preview");
    const previewEmpty = this.previewEl.dataset.empty;
    if (nameType === "dropdown") {
      this.nameEl.addEventListener("change", (e) => {
        this.properties.name = e.target.value;
        this.previewEl.textContent = e.target.value || previewEmpty;
        this.validateButton();
      });
    } else {
      this.nameEl.addEventListener("input", (e) => {
        this.properties.name = e.target.value;
        this.previewEl.textContent = e.target.value || previewEmpty;
        this.validateButton();
      });
    }
  }

  stepHalo() {
    this.variantEls = this.querySelectorAll(".js-variant-item");
    this.variantEls?.forEach((variant) => {
      variant.addEventListener("click", () => {
        this.properties.halo = variant.dataset.variantTitle;
        this.variantId.value = variant.dataset.variantId;
        this.priceEls.forEach(
          (price) => (price.textContent = variant.dataset.variantPrice)
        );
        this.variantEls.forEach((x) =>
          x.classList.remove(this.config.selectedClass)
        );
        variant.classList.add(this.config.selectedClass);
        this.validateButton();
      });
    });
  }

  resetStep(step) {
    switch (step) {
      case "color":
        this.colors?.forEach((x) =>
          x.classList.remove(this.config.selectedClass)
        );
        this.changeBreedImage();
        break;
      case "breed":
        this.breedCharm = {};
        this.changeBreedImage();
        break;
      case "name":
        this.nameEl.value = "";
        this.previewEl.textContent = "My pet's name";
        break;
      case "halo":
        this.priceEls.forEach(
          (price) => (price.textContent = price.dataset.price)
        );
        this.variantEls.forEach((x) =>
          x.classList.remove(this.config.selectedClass)
        );
        break;
      default:
        break;
    }
  }

  stepFinal() {
    this.removes?.forEach((remove) => {
      remove.addEventListener("click", () => {
        const step = remove.dataset.step;
        this.currentStep = step;
        this.goToStep(step);
        this.resetStep(step);
        this.properties[step] = "";
        this.validateButton();
      });
    });
  }

  addEventStep() {
    this.stepColor();
    this.stepBreed();
    if (this.enableName === "true") {
      this.stepName();
    }
    this.stepHalo();
    this.stepFinal();
  }

  validateButton() {
    const button = this.querySelector(
      '.js-button[data-step="' + this.currentStep + '"]'
    );
    if (!button) {
      return;
    }
    button.disabled = true;
    switch (this.currentStep) {
      case "color":
        button.disabled = this.properties.color === "";
        break;
      case "breed":
        button.disabled = this.properties.breed === "";
        break;
      case "name":
        button.disabled = this.properties.name === "";
        break;
      case "halo":
        button.disabled = this.properties.halo === "";
        break;
      default:
        break;
    }
  }

  debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }
}

customElements.define("custom-personalizer", Personalizer);
